import { useEffect } from 'react';

export const useEscape = (options = {}) => {
  const { action } = options;

  useEffect(() => {
    /**
     * on keydown handler
     * @param {*} event
     * @returns
     */
    const keyDownHandler = (event) => {
      if (event.target.name !== undefined) {
        return;
      }

      if (event.key === 'Escape') {
        action();
      }
    };

    window.addEventListener('keydown', keyDownHandler);

    return () => {
      window.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  return null;
};
